import { connect } from 'react-redux';
import ArcadeCabinetsButtonAndPanel from './ButtonAndPanel';
import { resetCabinetEditor } from '../actions';
import { getArcadeCabinetId, hasArcadeCabinetId, hasArcadeCabinetRomId } from '../selectors';
import { getRomsRoms } from 'routes/roms/selectors';
import { selectRom } from '../actions';
import { getRoms } from 'routes/roms/actions';

const mapStateToProps = (state) => ({
    slide: hasArcadeCabinetId(state),
    arcadeCabinetId: getArcadeCabinetId(state),
    hasArcadeCabinetRomId: hasArcadeCabinetRomId(state),
    romOptions: getRomsRoms(state)
});
const mapDispatchToProps = {
    getRoms,
    resetCabinetEditor,
    selectRom
 };

export default connect(mapStateToProps, mapDispatchToProps)(ArcadeCabinetsButtonAndPanel);
